import { observer } from 'mobx-react-lite';
import { FC, useMemo, useState } from 'react';
import { IAppSelection } from '~/views/types';

export const AppSelection: FC<IAppSelection> = observer(
    ({ onChooseProfile, getUserProfiles, alertDialogSrv, showLoading }) => {
        const profiles = getUserProfiles?.() ?? [];
        // const profiles = [
        //     {
        //         uid: 'WG-NC-tKVZHD5JO2lYBG',
        //         displayName: '3437778633',
        //         wdollarBalance: '10',
        //         appCode: 'NC',
        //     },
        //     {
        //         uid: 'WG-NC-tKVZHD5JO2lYBG',
        //         displayName: '3437778633',
        //         wdollarBalance: '10',
        //         appCode: 'JP',
        //     },
        // ];

        const jp = useMemo(() => profiles.find(p => p.appCode === 'JP'), [profiles]);
        const nc = useMemo(() => profiles.find(p => p.appCode === 'NC'), [profiles]);

        const [selectedUid, setSelectedUid] = useState<string | null>(null);

        // toggle select/deselect
        const handleSelect = (uid: string) => {
            setSelectedUid(prev => (prev === uid ? null : uid));
        };

        const handleContinue = () => {
            if (selectedUid) onChooseProfile?.(selectedUid, alertDialogSrv);
        };

        const balanceText = (wd: string | number | undefined) => `WDOLLARS $${wd ?? 0}`;

        const formatWD = (wd: string | number | undefined) => `$${Number(wd ?? 0).toLocaleString()}`;

        if (profiles.length === 0) return null;

        const twoCards = Boolean(jp && nc);

        return (
            <>
                <h3 className="app-selection-header">Select a Game</h3>
                <p className="app-selection-text">Which account would you like to purchase for?</p>

                <div className={`app-select-grid ${twoCards ? 'two-cards' : ''}`}>
                    {jp && (
                        <button
                            type="button"
                            className={`app-card ${selectedUid === jp.uid ? 'selected' : ''}`}
                            onClick={() => handleSelect(jp.uid)}
                            aria-pressed={selectedUid === jp.uid}
                            disabled={showLoading}
                        >
                            <div className="app-card-left">
                                <div className="app-icon-wrap">
                                    <img
                                        className="app-icon"
                                        src="/assets/img/select-app-jp.png"
                                        alt="Jackpot Planet"
                                    />
                                    <img
                                        className="app-check"
                                        src="/assets/img/select-app-green-check.png"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                </div>
                                <div className="app-meta">
                                    <div className="app-name">Hard Rock Jackpot Planet</div>
                                    <div className="app-user">{jp.displayName}</div>
                                    <div className="app-balance-chip">
                                        <img
                                            className="wd-icon"
                                            src="/assets/img/letter-w-user-menu.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        <span className="wd-label">WDOLLARS</span>
                                        <span className="wd-value">{formatWD(jp.wdollarBalance)}</span>
                                    </div>
                                </div>
                            </div>
                        </button>
                    )}

                    {nc && (
                        <button
                            type="button"
                            className={`app-card ${selectedUid === nc.uid ? 'selected' : ''}`}
                            onClick={() => handleSelect(nc.uid)}
                            aria-pressed={selectedUid === nc.uid}
                            disabled={showLoading}
                        >
                            <div className="app-card-left">
                                <div className="app-icon-wrap">
                                    <img
                                        className="app-icon"
                                        src="/assets/img/select-app-nc.png"
                                        alt="Neverland Casino"
                                    />
                                    <img
                                        className="app-check"
                                        src="/assets/img/select-app-green-check.png"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                </div>
                                <div className="app-meta">
                                    <div className="app-name">Hard Rock Neverland Casino</div>
                                    <div className="app-user">{nc.displayName}</div>
                                    <div className="app-balance-chip">
                                        <img
                                            className="wd-icon"
                                            src="/assets/img/letter-w-user-menu.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        <span className="wd-label">WDOLLARS</span>
                                        <span className="wd-value">{formatWD(nc.wdollarBalance)}</span>
                                    </div>
                                </div>
                            </div>
                        </button>
                    )}
                </div>
                <div className="app-select-btn-wrap">
                    <button
                        type="button"
                        className="btn continue-btn"
                        disabled={!selectedUid || showLoading}
                        onClick={handleContinue}
                    >
                        Continue
                    </button>
                </div>
            </>
        );
    },
);
